// Role column registry for the GTCO roles table. Schema-driven: GtTable renders
// whatever this declares. Widths in px. `sort` maps to a filters.js ROLE_REGISTRY field.
export const ROLE_COLUMNS = [
  { key: 'ref',                  label: 'ID',           render: 'ref',       width: 120, frozen: true, sort: 'id' },
  { key: 'title',                label: 'Role',         render: 'role',      width: 260, frozen: true, sort: 'title' },
  { key: 'expertise_domain',     label: 'Expertise',    render: 'domain',    width: 140, sort: 'expertise_domain' },
  { key: 'status',               label: 'Status',       render: 'rolestatus',width: 120, sort: 'status' },
  { key: 'placement_model',      label: 'Model',        render: 'placement', width: 150, sort: 'placement_model' },
  { key: 'placement_fee_percent',label: 'Fee %',        render: 'feepct',    width: 90,  sort: 'placement_fee_percent' },
  { key: 'has_role_profile',     label: 'Profile',      render: 'yesno',     width: 100 },
  { key: 'rate_card_count',      label: 'Rate cards',   render: 'countpill', width: 100 },
  { key: 'submission_count',     label: 'Submitted',    render: 'countpill', width: 100 },
  { key: 'created_at',           label: 'Created',      render: 'ukdate',    width: 110, sort: 'created_at' },
];

export const ROLE_COLUMNS_EXTRA = [
  { key: 'client_name',          label: 'Client',       render: 'text',      width: 190, sort: 'client_name' },
  { key: 'client_contact_name',  label: 'Contact',      render: 'text',      width: 170, sort: 'client_contact_name' },
  { key: 'client_contact_email', label: 'Contact email',render: 'email',     width: 210, sort: 'client_contact_email' },
  { key: 'has_jd',               label: 'JD on file',   render: 'yesno',     width: 100 },
  { key: 'updated_at',           label: 'Modified',     render: 'ukdate',    width: 110, sort: 'updated_at' },
];

export const ALL_ROLE_COLUMNS = [...ROLE_COLUMNS, ...ROLE_COLUMNS_EXTRA];
